import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import {
  PiArrowRightLight,
  PiBankLight,
  PiFirstAidKitLight,
  PiHandshakeLight,
  PiHeartLight,
  PiMapPinAreaLight,
  PiSoccerBallLight,
  PiTrashLight,
  PiUsersThreeLight,
} from 'react-icons/pi';
import Pharmacies from '../Pharmacies/Pharmacies';
import { getSiteSettings } from '../../api/siteSettings';

const servicesData = [
  {
    id: 1,
    title: 'CIMER',
    image: '/assets/images/cimer.png',
    link: 'https://www.cimer.gov.tr/',
    iconColor: 'rgb(8, 73, 119)',
    targetBlank: true
  },
  {
    id: 2,
    title: 'Nikah İşlemleri',
    icon: PiHeartLight,
    link: '/nikah-islemleri',
    iconColor: 'rgb(8, 73, 119)',
    targetBlank: false
  },
  {
    id: 3,
    title: 'Beyaz Masa',
    icon: PiHandshakeLight,
    link: '#',
    iconColor: 'rgb(8, 73, 119)',
    targetBlank: true
  },
  {
    id: 4,
    title: 'Nöbetçi Eczaneler',
    icon: PiFirstAidKitLight,
    link: '#',
    isPharmacy: true,
    iconColor: 'rgb(8, 73, 119)',
    targetBlank: false
  },
  {
    id: 5,
    title: 'İmar Hizmetleri',
    icon: PiMapPinAreaLight,
    link: 'https://keos.iskenderun.bel.tr:8787/imardurumu/index.aspx',
    iconColor: 'rgb(8, 73, 119)',
    targetBlank: true
  },
  {
    id: 6,
    title: 'Temizlik Hizmetleri',
    icon: PiTrashLight,
    link: '#',
    comingSoon: true,
    iconColor: 'rgb(8, 73, 119)',
    targetBlank: false
  },
  {
    id: 7,
    title: 'Spor Randevu',
    icon: PiSoccerBallLight,
    link: '/hizmet-rehberi/spor-randevu',
    iconColor: 'rgb(8, 73, 119)',
    targetBlank: false
  },
  {
    id: 8,
    title: 'Sosyal Tesisler',
    icon: PiUsersThreeLight,
    link: '/sosyal-tesisler',
    iconColor: 'rgb(8, 73, 119)',
    targetBlank: false
  },
  {
    id: 9,
    title: 'Meclis Kararları',
    icon: PiBankLight,
    link: '/meclis-kararlari',
    iconColor: 'rgb(8, 73, 119)',
    targetBlank: false
  }
];

export default function ServicesGrid() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [comingSoonModalIsOpen, setComingSoonModalIsOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [services, setServices] = useState(servicesData);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await getSiteSettings();
        if (response.isSuccess) {
          const updatedServices = servicesData.map((service) => {
            if (service.id === 3) {
              return {
                ...service,
                link: response.data.whiteDeskUrl || service.link
              };
            }
            return service;
          });

          setServices(updatedServices);
        }
      } catch (error) {
        console.error('Error fetching site settings:', error);
      }
    };

    fetchSiteSettings();
  }, []);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '95%',
      maxWidth: '520px',
      maxHeight: '90vh',
      overflow: 'auto',
      borderRadius: '24px',
      padding: '2rem',
      border: '1px solid #e2e8f0',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
    },
    overlay: {
      backgroundColor: 'rgba(15, 23, 42, 0.65)',
      backdropFilter: 'blur(4px)',
      zIndex: 9999
    }
  };

  const comingSoonStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '90%',
      maxWidth: '500px',
      textAlign: 'center',
      padding: '30px'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)'
    }
  };

  const handleServiceClick = (e, service) => {
    e.preventDefault();
    if (service.comingSoon) {
      setSelectedService(service);
      setComingSoonModalIsOpen(true);
    } else if (service.isPharmacy) {
      setModalIsOpen(true);
    } else if (service.link !== '#') {
      if (service.targetBlank) {
        window.open(service.link, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = service.link;
      }
    }
  };

  Modal.setAppElement('#root');

  return (
    <div className="services-grid">
      <div className="services-grid-title">
        <h2>Hizmetlerimiz</h2>
        <p>Size sunduğumuz tüm hizmetlere ilgili tüm bilgilere bu alandan ulaşabilirsiniz.</p>
      </div>

      <div className="services-grid-content">
        <div className="services-grid-content-card row">
          {services.map((service) => {
            const ServiceIcon = service.icon;

            return (
              <a
                key={service.id}
                href={service.link}
                className="services-card col-md-4"
                onClick={(e) => handleServiceClick(e, service)}
                target={service.targetBlank ? '_blank' : ''}
                rel={service.targetBlank ? 'noopener noreferrer' : ''}
              >
                <div className="services-card-left">
                  <div className="services-card-icon">
                    {service.image ? (
                      <img src={service.image} alt={service.title} />
                    ) : (
                      <ServiceIcon size={42} color={service.iconColor} />
                    )}
                    <h4>{service.title}</h4>
                  </div>
                </div>
                <div className="services-card-right">
                  <div className="services-card-arrow">
                    <span>
                      <PiArrowRightLight size={24} color="#64748b" />
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        style={customStyles}
        contentLabel="Nöbetçi Eczaneler"
      >
        <button
          onClick={() => setModalIsOpen(false)}
          style={{
            position: 'absolute',
            right: '16px',
            top: '16px',
            background: '#f1f5f9',
            border: 'none',
            fontSize: '18px',
            cursor: 'pointer',
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#64748b',
            transition: 'all 0.2s ease',
            outline: 'none'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#e2e8f0';
            e.currentTarget.style.color = '#334155';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#f1f5f9';
            e.currentTarget.style.color = '#64748b';
          }}
        >
          ✕
        </button>
        <Pharmacies />
      </Modal>

      <Modal
        isOpen={comingSoonModalIsOpen}
        onRequestClose={() => setComingSoonModalIsOpen(false)}
        style={comingSoonStyles}
        contentLabel="Yakında"
      >
        <button
          onClick={() => setComingSoonModalIsOpen(false)}
          style={{
            position: 'absolute',
            right: '10px',
            top: '10px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer'
          }}
        >
          ×
        </button>
        <div style={{ marginBottom: '20px' }}>
          <img src="/assets/images/logo.png" alt="Logo" style={{ maxWidth: '200px' }} />
        </div>
        <h3 style={{ color: '#0F75BC', marginBottom: '20px' }}>
          {selectedService?.title}
        </h3>
        <p style={{ fontSize: '18px', color: '#333' }}>
          Yakında hizmetinize açılacaktır
        </p>
      </Modal>
    </div>
  );
}
